import { createFileRoute } from '@tanstack/react-router'
import { RealEstateInterestZonesTab } from '~/components/routes/development/real-estate/interest-zones/real-estate-interest-zones-tab'
import { AREA_READ, realEstateTabGuard } from '~/components/routes/development/real-estate/tabs'

export const Route = createFileRoute('/_authenticated/development/real-estate/interest-zones')({
  staticData: { permission: AREA_READ },
  beforeLoad: realEstateTabGuard('interest-zones'),
  component: RealEstateInterestZonesTab,
})
